import { PropsWithChildren } from 'react';

import { Stack } from 'libs/ui';
import { StackProps } from 'libs/ui/Stack/types';

interface Props extends PropsWithChildren, StackProps {}

export const ActionsList = ({ children, ...props }: Props) => (
  <Stack direction="row" spacing={12} {...props}>
    {children}
  </Stack>
);
